import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import ModalUpdateDocument from '@components/Anexos/ModalUpdateDocument';

import { getListAnexos, updateAnexo } from '@actions/documents'
import { sendActionToBitacora  } from '@actions/bitacora';

import './style.scss'

class ProcessDictionary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: false,
      dictionaries: [],
      itemsBreadcrumb: [],
      hasFileData: false,
      showModalUpdateDocument: {
        isVisible: false,
        continueAction: null,
      },
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async (ruta = '') => {
    const { getListAnexos } = this.props;
    this.setState({ loadingTable: true });
    const response = await getListAnexos(ruta);
    if (!response?.status) {
      return this.setState({
        dictionaries: this.formatData(response.data),
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false, hasFileData: false });
  };
  
  formatData = (data) => {
    if (data.length) {
      const newData = data.reduce((accum, item, index) => {
        const getLastCharacter = item.slice(-1)
        const splitName = item.split("/")
        if (item === 'Procesos/Anexos/') {
          this.setBreadCrumb(splitName)
          return accum
        }
        if (index === 0) {
          splitName.pop()
          this.setBreadCrumb(splitName)
          splitName.pop()
          const joinFullPath = splitName.join('/')
          accum.push({
            name: '. . /',
            fullPath: joinFullPath,
            type: 'FOLDER'
          })
        }
        else if (getLastCharacter === '/') {
          accum.push({
            name: this.validateNameIsEqualLanguage(splitName[splitName.length - 2]),
            fullPath: item,
            type: 'FOLDER'
          })
        } else {
          accum.push({
            name: this.validateNameIsEqualLanguage(splitName[splitName.length - 1]),
            fullPath: item,
            type: 'FILE'
          })
        }
        return accum
      }, [])
      const existFileIntoData = newData.find(item => item.type === 'FILE')
      this.setState({hasFileData: !!existFileIntoData })
      return newData
    } 
      return []
  }

  validateNameIsEqualLanguage = (name) => {
    const { itemsLanguageCatalog } = this.props
    const isLanguage = itemsLanguageCatalog.find(item => item.key === name)
    return isLanguage ? isLanguage.label : name
  }

  setBreadCrumb = (data) => {
    const getBreadcrumbItems = data.map(item => ({ label: this.validateNameIsEqualLanguage(item) }))
    this.setState({
      itemsBreadcrumb: getBreadcrumbItems
    })
  }

  openFolder = async (data) => this.loadData(data.fullPath)

  onUpdateDocumentModal = (node) => {
    this.setState({
      showModalUpdateDocument: {
        isVisible: true,
        value: '',
        nameDocument: node.name,
        continueAction: ({documentFile, justification}) => this.onUploadDocumet({...node, documentFile, justification}),
      },
    });
  }

  onUploadDocumet = async (data) => {
    const { t, updateAnexo, sendActionToBitacora } = this.props
    const response = await updateAnexo(data)
    if(!response?.status) {
      const dataBitacora = {
        transactionName: 'actAnexos',
        reason: `${data.name} - ${data.fullPath} || ${data.justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
      this.onHideModalUpdateDocument()
    }
  }

  onHideModalUpdateDocument = () => {
    this.setState({
      showModalUpdateDocument: {
        isVisible: false,
      },
    });
  };

  columnName = (node, detail) => {
    if (node.type === 'FOLDER') {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <span className='link' onClick={()=> this.openFolder(node)}>
            <img src='/assets/img/icon-folder.svg' className='p-mr-4' width='32' height='32'/>
            {node.name}
          </span>
        </div>
      )
    }
    if (node.type === 'FILE') {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <span>
            <img src='/assets/img/icon-file.svg' className='p-mr-4' width='32' height='32'/>
            {node.name}
          </span>
        </div>
      )
    }
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
        <span>{node.name}</span>
      </div>
    )
  };

  columnAction = (node, detail) => {
    const { t } = this.props
    if (node.type === 'FOLDER') {
      return ""
    }
    if (node.type === 'FILE') {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            icon="pi pi-cloud-upload"
            label={t('Actualizar')}
            className="p-button-success"
            onClick={() => this.onUpdateDocumentModal(node)}
          />
        </div>
      )
    }
  };

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  render() {
    const { history, t } = this.props;
    const { loadingTable, dictionaries, itemsBreadcrumb, showModalUpdateDocument, hasFileData } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
      </>
    );

    const home = { icon: 'pi pi-home'  }

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Anexos')} rightComponent={rightHeader} />
          <div className="card p-grid">
            <div className='p-col-12'>
              <BreadCrumb model={itemsBreadcrumb} home={home} />
            </div>
            <div className="p-col-12 p-mt-2">
              <DataTable
                value={dictionaries}
                lazy
                loading={loadingTable}
                className="table-anexos"
              >
                <Column
                  header={t('Nombre')}
                  body={this.columnName}
                />
                { hasFileData && (
                  <Column
                    header={t('Acción')}
                    body={this.columnAction}
                    className='columns-action'
                  />
                )}
              </DataTable>
            </div>
          </div>
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        { showModalUpdateDocument.isVisible && (
          <ModalUpdateDocument
             nameDocument={showModalUpdateDocument.nameDocument}
              onHidden={() => this.onHideModalUpdateDocument()}
              onContinueAction={showModalUpdateDocument.continueAction}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  itemsLanguageCatalog: state.catalogs.itemsLanguageCatalog
});

const mapDispatchToProps = {
  getListAnexos,
  updateAnexo,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ProcessDictionary);
